import { render, staticRenderFns } from "./modelling.vue?vue&type=template&id=67b25d83&"
import script from "./modelling.vue?vue&type=script&lang=js&"
export * from "./modelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports